import { File } from "./File/File";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Files.module.css";
import { downloadFile } from "@coworker/apprestructured/src/shared/helpers/downloadFile";
import { Trans } from "@coworker/locales";

type FilesProps = {
  files: File[];
  disabled: boolean;
};

export const Files = ({ files, disabled }: FilesProps) => {
  return (
    <div className={styles["container"]}>
      <FixaText textStyle="Heading.S">
        <Trans>filesStringCapitalized</Trans>
      </FixaText>
      <div className={styles["filesWrapper"]}>
        {files.map((file) => (
          <File
            key={`${file.name}-${file.size}-${file.lastModified}`}
            file={file}
            disabled={disabled}
            onDownloadClick={downloadFile}
          />
        ))}
      </div>
    </div>
  );
};
